module.exports = __webpack_public_path__ + "img/gather_sleeve_opening.e8b13b62.png";